import {
  ShopOutlined,
  UserOutlined,
} from '@ant-design/icons';
import React from 'react';

const AccountItemIcon = ({icon}: {icon:'accounts' | 'users'}) => (
  icon === 'accounts' ? <ShopOutlined /> : <UserOutlined />
);

export default AccountItemIcon;